import { useMemo } from "react";
import useSWR from "swr";
import { fetcherPost, fetcher, fetcherDelete } from "../utils/axios";

const endpoints = {
    key: '/editors',
    create: '/editor',
    searchQuery: '?search='
}

export async function fetchEditors(args) {
    const data = await fetcher(args);
    return data;
}

export function useGetEditors(search = '', skip = false) {
    const { data, isLoading, error, isValidating, mutate } = useSWR(
        skip ? null : (search ? [endpoints.key + endpoints.searchQuery + search] : endpoints.key),
        fetchEditors,
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            errorRetryCount: 0
        }
    );
    const memoizedValue = useMemo(() => {
        const filteredEditors = data?.filter(editor => editor.userRole === 3) || [];
        return {
            editors: filteredEditors,
            isEditorsLoading: isLoading,
            editorsError: error,
            isEditorsValidating: isValidating,
            isEditorsEmpty: !isLoading && !filteredEditors.length,
            mutateEditors: mutate
        }
    }, [data, error, isLoading, isValidating]);

    return memoizedValue;
}

export async function createAndUpdateEditor(payload) {
    const data = await fetcherPost([endpoints.create, payload]);
    return data?.data;
}

export async function deleteEditor(editorIds) {
    const data = await fetcherDelete([endpoints.key, { data: { ids: Array.isArray(editorIds) ? editorIds : [editorIds] } }]);
    return data?.data;
}